<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Employee Job Types
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <div
          class="relative-position"
          style="min-height: 200px; max-height: 75vh; overflow: auto;"
        >
          <q-list
            bordered
            separator
          >
            <q-item
              v-for="employeeJobType in employeeJobTypes.data"
              :key="employeeJobType.id"
              clickable
              @click.stop="toggle(employeeJobType)"
            >
              <q-item-section avatar>
                <q-checkbox
                  class="no-pointer-events"
                  :model-value="!!$_.find(user.userEmployeeJobTypes.data, userEmployeeJobType => userEmployeeJobType.employeeJobTypeId === employeeJobType.id)"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ employeeJobType.name }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
          <q-inner-loading :showing="employeeJobTypes.loading" />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import User from 'src/models/user/User'

export default {
  name: 'AssignUserEmployeeJobTypes',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    user: {
      type: User,
      required: true
    }
  },
  configuration: ['employeeJobTypes'],
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    toggle (employeeJobType) {
      if (this.user.hasSavedJobType(employeeJobType)) {
        return
      }

      if (this.user.hasJobType(employeeJobType)) {
      // Remove
        this.user.removeJobType(employeeJobType)
      } else {
      // Add
        this.user.addJobType(employeeJobType)
      }
    }
  }
}
</script>
